import base from "@/store/utils/api-route/base";

const transaksiSnapcleanAPI = {
	customer: {
		list: `${base.meta}list_transaksi_snap_konsumen`,
		info: `${base.meta}ringkasan_transaksi_snap_konsumen`,
		paylink: `${base.meta}list_riwayat_penggunaan_paylink`,
	},
	detail: `${base.meta}data_detail_transaksi_snap`,
	delete: `${base.pembatalan}penghapusan_transaksi_snapclean`,
	export: {
		job: `${base.export}job`,
		track: `${base.export}track_redis_job`,
		delete: {
			cluster: `${base.export}delete_cluster_redis_job`,
			master: `${base.export}delete_master_redis_job`,
		},
	},
}

export default transaksiSnapcleanAPI